import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { TruncatePipeModule } from '@shared';
import { DropdownMenuWithIconsModule } from '@shared/dropdown-menu-with-icons/dropdown-menu-with-icons.module';
import { MojoAvatarModule } from 'mojo-avatar';
import { MojoCardModule } from 'mojo-card';
import { FeatureFlagsModule } from 'mojo-feature-flags';
import { MojoPhoneInputModule } from 'mojo-phone-input';

import { MaterialModule } from '@material/material.module';
import { jobPageReducers } from '@modules/job-page/store';
import { BatchOperationToolbarModule } from '@shared/batch-operation-toolbar/batch-operation-toolbar.module';
import { BadgesModule } from '@shared/candidate-badges/candidate-badges.module';
import { CandidateCommonModule } from '@shared/candidate-common/candidate-common.module';
import { CandidateResumeModule } from '@shared/candidate-resume/candidate-resume.module';
import { PdfPreviewTooltipModule } from '@shared/pdf-preview-tooltip/pdf-preview-tooltip.module';
import { ResumeLinkModule } from '@shared/resume-link/resume-link.module';
import { SocialLinksModule } from '@shared/social-links/social-links.module';

import { AtsButtonModule } from '../ats-button/ats-button.module';
import { CandidateContactComponent } from './components/candidate-contact/candidate-contact.component';
import { CandidateResumePreviewLinkComponent } from './components/candidate-resume-preview-link/candidate-resume-preview-link.component';
import { CandidateCardComponent } from './containers/candidate-card/candidate-card.component';
import { MojoPrivilegesModule } from 'mojo-privileges';
import { CandidateStatusBadgeComponent } from './components/candidate-status-badge/candidate-status-badge.component';
import { NotesModule } from '@modules/notes/notes.module';
import { SideNavCandidateViewComponent } from '@shared/candidate/side-nav-candidate/components/side-nav-candidate-view/side-nav-candidate-view.component';
import { CandidateTalentPoolsComponent } from '@shared/candidate/side-nav-candidate/components/side-nav-candidate-talent-pools/candidate-talent-pools.component';
import { SideNavCandidateViewContainerComponent } from '@shared/candidate/side-nav-candidate/containers/side-nav-candidate-view.container';
import { TalentPoolAddCandidateButtonComponent } from '@shared/candidate/side-nav-candidate/components/talent-pool-add-candidate-button/talent-pool-add-candidate-button.component';
import { AddCandidateModalComponent } from '@shared/candidate/side-nav-candidate/components/talent-pool-add-candidate-modal/add-candidate-modal.component';
import { ReactiveFormsModule } from '@angular/forms';
import { DetailsModule } from '@modules/candidates/child-modules/details/details.module';
import { EffectsModule } from '@ngrx/effects';
import { CandidateSideNavEffects } from '@shared/candidate/side-nav-candidate/store/candidate-side-nav.effects';
import { SideNavModule } from '@shared/side-nav/side-nav.module';
import { MojoFeatureExtensionsModule } from 'mojo-feature-extensions';
import { TasksModule } from '@modules/tasks/tasks.module';
import { CandidateAttachmentsModule } from '@modules/candidates/+attachments';
import { MojoTagModule } from 'mojo-tag';
import { TalentPoolsItemModule } from '@modules/talent-pools-page/components/talent-pools-item/talent-pools-item.module';
import { SideNavService } from '@shared/candidate/side-nav-candidate/services/side-nav.service';
import { PdfViewerAdapterModule } from '@shared/pdf-viewer-adapter/pdf-viewer-adapter.module';
import { MojoTalentPoolsModule } from 'mojo-talent-pools';
import { TALENT_POOLS_SERVICE } from '@core/injection-tokens/talent-pools.injection.token';
import { MojoCopiableTooltipModule } from 'mojo-copiable-tooltip';
import { CandidateExtraInfoModule } from '@modules/candidate-extra-info/candidate-extra-info.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { SimpleCandidateModule } from '@shared/simple-candidate/simple-candidate.module';

@NgModule({
  declarations: [
    CandidateResumePreviewLinkComponent,
    CandidateContactComponent,
    CandidateCardComponent,
    CandidateStatusBadgeComponent,
    SideNavCandidateViewComponent,
    CandidateTalentPoolsComponent,
    SideNavCandidateViewContainerComponent,
    TalentPoolAddCandidateButtonComponent,
    AddCandidateModalComponent,
  ],
  imports: [
    StoreModule.forFeature('jobPage', jobPageReducers),
    AtsButtonModule,
    CommonModule,
    MojoAvatarModule,
    ResumeLinkModule,
    MatIconModule,
    CandidateResumeModule,
    BadgesModule,
    SocialLinksModule,
    RouterModule,
    PdfPreviewTooltipModule,
    CandidateCommonModule,
    FeatureFlagsModule,
    MojoCardModule,
    MatRadioModule,
    MojoPhoneInputModule,
    MaterialModule,
    BatchOperationToolbarModule,
    MojoPrivilegesModule,
    TruncatePipeModule,
    ReactiveFormsModule,
    DetailsModule,
    MojoTalentPoolsModule.forRoot(TALENT_POOLS_SERVICE),
    EffectsModule.forFeature([CandidateSideNavEffects]),
    SideNavModule,
    MojoFeatureExtensionsModule,
    TasksModule,
    NotesModule,
    DropdownMenuWithIconsModule,
    CandidateAttachmentsModule,
    MojoTagModule,
    TalentPoolsItemModule,
    PdfViewerAdapterModule,
    MojoCopiableTooltipModule,
    CandidateExtraInfoModule,
    InfiniteScrollModule,
    SimpleCandidateModule,
  ],
  exports: [
    CandidateContactComponent,
    CandidateCardComponent,
    CandidateResumePreviewLinkComponent,
    CandidateStatusBadgeComponent,
    TalentPoolAddCandidateButtonComponent,
  ],
  providers: [SideNavService],
})
export class CandidateModule {}
